module.exports = __webpack_public_path__ + "img/form-banner.28efb6e3.png";